export enum ClothsConnectionType {
	lsup = 0,
	csup = 1,
	rsup = 2,
	rinf = 3,
	cinf = 4,
	linf = 5,
}

export enum CutTypes {
	noSet = 0,
	N = 1,
	AB = 2,
	NB = 3,
	TB = 4,
}

export enum Cuts {
	FIXED_LEFT = 1,
	FIXED_RIGHT = 2,
	SYMMETRICAL = 3,
}

export enum NetType {
	SQUARE = "SQUARE",
	DIAMOND = "DIAMOND",
}
